import { Form, FormField } from "#shared/form";

export class SignInCodeStepRetryForm extends Form<{ captcha: string }> {
  constructor() {
    super({
      captcha: new FormField<string>(''),
    }); 

    this.formData.captcha.addValidator({
      message: 'Необходимо подтвердить, что вы не робот',
      validateFn: (value) => !!value,
    });
  }

  public override reset() {
    this.formData.captcha.value = '';
  }
}